import { render } from "./authentication.vue?vue&type=template&id=b6bcbfec&scoped=true"
import script from "./authentication.vue?vue&type=script&lang=js"
export * from "./authentication.vue?vue&type=script&lang=js"

import "./authentication.vue?vue&type=style&index=0&id=b6bcbfec&lang=scss&scoped=true"
import "./authentication.vue?vue&type=style&index=1&id=b6bcbfec&lang=css"

import exportComponent from "/Users/a/Desktop/app/pulizhenkong_pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6bcbfec"]])

export default __exports__